import { BadgeSizes, BadgeThemes } from "./types"
import { BadgeWrapper } from "./BadgeWrapper"
import { Featured } from "./Featured"

export interface BadgeProps {
  size?: BadgeSizes
  text: string
  theme?: BadgeThemes
}

const Badge = ({ size = "md", text, theme = "default" }: BadgeProps) => {
  return (
    <BadgeWrapper size={size} theme={theme}>
      {text}
    </BadgeWrapper>
  )
}

Badge.Featured = Featured

export { Badge }
